import React from 'react';
import { Link } from 'react-router-dom';
import { RotateCw, TriangleAlert } from 'lucide-react';
import EmptyState from './site/EmptyState';

/** Keeps a crash on an order page from taking down the rest of the app. Must render inside the router. */
class OrderErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV === 'development') {
      console.error('Order page crashed:', error, errorInfo);
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className="pk-page">
        <div className="pk-container pk-container--narrow">
          <EmptyState
            role="alert"
            icon={<TriangleAlert />}
            title="We couldn't show this order"
            text="Something went wrong while showing this page. Reload it, or go back to your orders."
            actions={
              <>
                <button
                  type="button"
                  className="pk-btn pk-btn--primary pk-btn--sm"
                  onClick={() => window.location.reload()}
                >
                  <RotateCw aria-hidden="true" /> Reload page
                </button>
                <Link
                  to="/profile"
                  className="pk-btn pk-btn--secondary pk-btn--sm"
                  onClick={() => this.setState({ hasError: false })}
                >
                  View my orders
                </Link>
              </>
            }
          />
        </div>
      </main>
    );
  }
}

export default OrderErrorBoundary;
